/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownSeniorityLevel } from '../models/db_DropdownSeniorityLevel';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SeniorityLevels {
    /**
     * Get a list of seniority levels
     * @returns db_DropdownSeniorityLevel OK
     * @throws ApiError
     */
    public static listSeniorityLevels(): CancelablePromise<Array<db_DropdownSeniorityLevel>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/seniority-levels',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
